export default "__VITE_ASSET__jcN1tXXH__"